var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMemberinline = function SvgMemberinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 4.375h4.22c.128 0 .234.105.234.234v1.172H7.656V4.61c0-.129.106-.234.235-.234Zm-1.64.234v1.172H4.375c-1.034 0-1.875.841-1.875 1.875v2.813h15V7.656c0-1.034-.84-1.875-1.875-1.875H13.75V4.61c0-.905-.735-1.64-1.64-1.64H7.89c-.905 0-1.64.735-1.64 1.64Zm11.25 6.797h-5.625v.938a.936.936 0 0 1-.938.937H9.063a.936.936 0 0 1-.938-.937v-.938H2.5v3.75c0 1.034.84 1.875 1.875 1.875h11.25c1.034 0 1.875-.84 1.875-1.875v-3.75Z",
    fill: "#black"
  })));
};
export default SvgMemberinline;